import type { FaireProductEntity } from "../../entity_types/product";

export const p_wk78tp436p: FaireProductEntity = {
  token: "p_wk78tp436p",
  type: "product",
  name: "Through The Woods Set of Two Stitched Notebooks Journals",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2d00a1abc3456129d82853c6425f11d2232101d946daadd44a161213de28b29b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85df966b9aa2ffe6ec1978550675b713b843da7e00008bc16c65c6213f809e4a.jpeg",
    "https://cdn.faire.com/fastly/bd9d5621dc294ebfe8db111cdac759024cb0a87d1f1dfa5d3b5ad3b5577a47a7.jpeg",
    "https://cdn.faire.com/fastly/ba3f232c81d2ea3ee0defd4ba586b16c21a4d8d861877c5e42bdcb9a8b7bfad3.jpeg",
    "https://cdn.faire.com/fastly/05427f0d5f204a2a5b29a6918b66ea746bbc6b2a1e311d86ec35845d01ca7c6e.jpeg",
  ],
  priceDollars: 8,
  description:
    "Who among us does not have an entire ocean of thoughts floating around in our heads? Nobody! A notebook is the perfect way to calm the cranial seas... simply write things down. And this set of 2 gives you so many options - make one messy, one clean. One to remember, one to forget. Likes, dislikes. Business in the front, party in the back. Have fun seeing what your thought waves will come up with.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:47.074Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
